import React, { useState } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import './OurClients.css';

import Heading from '../../../utls/Heading';

const OurClients = () => {
    const [autoplay, setAutoplay] = useState(true);

    const clientData = [
        {
            // imgSrc: "https://blueberrywebsites.azureedge.net/bbt/images/clientImg.png",
            name: 'Archit Handa',
            imgsrc: "https://blueberrywebsites.azureedge.net/bbt/icons/clientStar%20Full.svg",
            imgsrc2: "https://blueberrywebsites.azureedge.net/bbt/icons/clientStar%20Half.svg",
            review: '“BBT mobile app has proven invaluable for our frequent travelers. Notifications and real-time travel advisories help our team remain updated even during remote trips, with offline access being an added perk and secure authentication an extra advantage.”'
        },
        {
            // imgSrc: "https://blueberrywebsites.azureedge.net/bbt/images/clientimg2.png",
            name: 'Shubham Sharma',
            imgsrc: "https://blueberrywebsites.azureedge.net/bbt/icons/clientStar%20Full.svg",
            imgsrc2: "https://blueberrywebsites.azureedge.net/bbt/icons/clientStar%20Half.svg",
            review: `“BBT's open API and robust integration capabilities were essential in improving booking efficiency and minimizing booking errors, automating workflows and custom policy enforcement have proven extremely valuable while their reporting interface could use improvement.”`
        },
        {
            // imgSrc: "https://blueberrywebsites.azureedge.net/bbt/images/clientimg3.png",
            name: 'Rahul Saini',
            imgsrc: "https://blueberrywebsites.azureedge.net/bbt/icons/clientStar%20Full.svg",
            imgsrc2: "https://blueberrywebsites.azureedge.net/bbt/icons/clientStar%20Half.svg",
            review: '“Blueberry Traveller App has quickly become my trusted travel partner. From real-time flight tracking updates and notifications about delays or gate changes to its itinerary builder that helps me organize all my travel details -- flights, hotels, meeting schedules and restaurant reservations -- in one central place -- I find this more efficient than using multiple apps for each journey.”'
        },
        {
            // imgSrc: "https://blueberrywebsites.azureedge.net/bbt/images/clients2.png",
            name: 'Varsha Matlani',
            imgsrc: "https://blueberrywebsites.azureedge.net/bbt/icons/clientStar%20Full.svg", // Full star
            imgsrc2: null, // No half star
            review: '“As someone who travels internationally frequently, I have found Blueberry Traveller App an indispensable travel resource. From currency conversion tools to weather forecasts and expense tracking options - having all my essential travel tools together in one app has greatly simplified my trip planning experience and is highly recommended by any frequent traveler.”'
        },
    ];
    const settings = {
        infinite: true, // Allows seamless looping
        speed: 10000, // Slow speed for smooth movement
        slidesToShow: 2.5, // Number of slides visible at a time
        slidesToScroll: 1, // Number of slides scrolled at a time
        autoplay: true, // Enables autoplay
        autoplaySpeed: 2000, // Set autoplay speed to 0 for continuous sliding
        cssEase: "linear", // Linear easing for smooth and uniform motion
        pauseOnHover: false, // Prevents pausing on hover
        arrows: false, // Hides navigation arrows
        draggable: false, // Prevents dragging (important for uninterrupted motion)
        swipe: false, // Disables swipe gestures (avoids accidental backward movement)
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                },
            },
        ],
    };
    

    return (
        <div className="our-clients">
            <Heading className='customheadings text-center'><span>What Our </span>Clients Say About Us</Heading>
            <Slider {...settings}>
                {clientData.map((client, index) => (
                    <div className="card clients-card d-flex flex-row bg-transparent border-0" key={index}>
                        {/* <LazyLoadImage
            effect="blur"
 src={client.imgSrc} className="card-img-tops pe-0 me-1" alt={`Client ${index + 1}`} loading="lazy"  /> */}
                        <div className="card-body client-card-body ps-0">
                            <div className="client-review-back">
                                <Heading className='grotesk-headings'>{client.name}</Heading>
                                <div className="d-flex gap-1">
                                    <LazyLoadImage
            effect="blur"
 src={client.imgsrc} alt="Star" className='star-w-h' loading="lazy" />
                                    <LazyLoadImage
            effect="blur"
 src={client.imgsrc} alt="Star" className='star-w-h'  loading="lazy" />
                                    <LazyLoadImage
            effect="blur"
 src={client.imgsrc} alt="Star" className='star-w-h'  loading="lazy" />
                                    <LazyLoadImage
            effect="blur"
 src={client.imgsrc} alt="Star" className='star-w-h'  loading="lazy" />
                                    {client.imgsrc2 ? (
                                        <LazyLoadImage
            effect="blur"
 src={client.imgsrc2} alt="Half Star" className='star-w-h'  loading="lazy" />
                                    ) : (
                                        <LazyLoadImage
            effect="blur"
 src={client.imgsrc} alt="Star" className='star-w-h'  loading="lazy" />
                                    )}
                                </div>
                                <p className='mt-3 grotesk-headings'>{client.review}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default OurClients;
